/**
 * Formats tile names for display.
 * This is a hack until we have slugs for tiles in place on the BE.
 */
export const formatTileNameForDisplay = (tileName: string): string => {
  const displayNameMap: Record<string, string> = {
    "Brand Story": "Brand\nStory",
    Subscribe: "Subscribe\n& Save",
  };

  return displayNameMap[tileName] || tileName;
};

export function getVisibleTileNameLength(tileName: string): number {
  return formatTileNameForDisplay(tileName).replace(/\n/g, "").length;
}
